const POPUP_CALLBACK_PATHS = ['/auth-callback', '/auth/callback'];

export function handleOAuthPopupCallback(
  opener: Window | null = window.opener,
  pathname: string = location.pathname,
  search: string = location.search,
): boolean {
  if (!opener || !POPUP_CALLBACK_PATHS.includes(pathname)) {
    return false;
  }

  const params = new URLSearchParams(search);
  const code = params.get('code');
  const error = params.get('error');

  if (code) {
    opener.postMessage({ type: 'MS_AUTH_CODE', code }, location.origin);
  } else if (error) {
    opener.postMessage({ type: 'MS_AUTH_ERROR', error }, location.origin);
  }
  window.close();
  return true;
}
